<template>
    <span class="help-block">
        <p v-for="(message, key) in errorMessages" :key="key" style="color: #8b130f">{{ message }}</p>
    </span>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    },
    collectionName: {
      type: String,
      default: ''
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    errorMessages() {
      if (!this.errors[this.collectionName]) {
        return {}
      }

      let errors = this.errors[this.collectionName]

      if (errors[this.index] && errors[this.index][this.value]) {
        return errors[this.index][this.value]
      }

      return {}
    }
  }
}
</script>
